import ReactAI from 'react-appinsights'

export function initApplicationInsights (key, browserHistory) {
  ReactAI.init({ instrumentationKey: key }, browserHistory)
  return ReactAI.ai()
}

/**
 * Sets the authenticed User context for tracking analytics. Currenlty sets it only for AppInsights
 *
 * @export
 * @param {string} authenticatedUserId
 * @param {string} accountId, this is optional
 */
export function setAuthenticatedUserContext (authenticatedUserId, accountId) {
  try {
    ReactAI.ai().setAuthenticatedUserContext(authenticatedUserId, accountId)
  } catch (err) {
    console.info(err.message)
  }
}

/**
 * Clears the authenticated user context from the current session
 *
 * @export
 */
export function clearAuthenticatedUserContext () {
  try {
    ReactAI.ai().clearAuthenticatedUserContext()
  } catch (err) {
    console.info(err.message)
  }
}

/**
 * Log a diagnostic message.
 *
 * @export
 * @param {string} message
 * @param {Object} properties
 * @param {any} severityLevel - see here https://github.com/Microsoft/ApplicationInsights-JS/blob/master/JavaScript/JavaScriptSDK.Interfaces/Contracts/Generated/SeverityLevel.ts
 */
export function trackTrace (message, properties, severityLevel) {
  try {
    ReactAI.ai().trackTrace(message, properties, severityLevel)
  } catch (err) {
    console.info(err.message)
  }
}



// WEBPACK FOOTER //
// ./src/util/analytics/ApplicationInsights.js